import { useMemo } from 'react';
import { DeviceInfo, useDimensions } from '@24i/nxg-sdk-quantum';
import { useImage } from '@24i/nxg-sdk-gluons/src/context/ImageService';
import { ORIENTATIONS } from '@24i/nxg-core-utils/src/constants';
import { SliderComponentProps } from '../types';

const useViewModel = (props: SliderComponentProps): SliderComponentProps => {
    const { isLandscape } = useDimensions();
    const { getImagesByOrientation } = useImage();
    const orientation = isLandscape ? ORIENTATIONS.LANDSCAPE : ORIENTATIONS.PORTRAIT;
    const isPortraitPhone = !DeviceInfo.isTablet() && orientation === ORIENTATIONS.PORTRAIT;
    const additionalFilteredItems = useMemo(
        () =>
            getImagesByOrientation(
                props.additionalItems,
                DeviceInfo.isTablet() ? ORIENTATIONS.LANDSCAPE : orientation
            ),
        [props.additionalItems, orientation]
    );

    return {
        ...props,
        additionalItems: additionalFilteredItems,
        isPortraitPhone,
    };
};

export { useViewModel };
